 <div v-if="getShowCustomizationPopup" class="popup-customization-save">
      <div class="popup-customization-content">
        <button class="close-btn btn-customization" @click="closeCustomizationPopup($event)">X</button>
        <h2>
            {{ $t('Save customization') }}
        </h2>
        <div class="customization-fields">
          <label for="name">{{$t('Name:')}}</label>
          <input type="text" v-model="name" id="name" />
  
          <label for="description">{{$t('Description:')}}</label>
          <textarea v-model="description" id="description"></textarea>
  
          <button type="button" @click="createCustomization()">{{$t('Submit')}}</button>
        </div>
      </div>
 </div>
